import { createContext } from 'react';

import type {
  AxisIdToScaleDomain,
  XYChartAxisInternal,
  XYChartSeriesWithDatapoints,
  WeakMapDatapoints,
} from '../types/xy-chart-internals.js';

export type XYChartDataContext = {
  axesMetadata: {
    isZoomEnabled: boolean;
    isPanEnabled: boolean;
    isInfinite: boolean;
  };
  axes: XYChartAxisInternal[];
  seriesWithDatapoints: XYChartSeriesWithDatapoints[];
  axisIdToScaleDomain: AxisIdToScaleDomain;
  datapointMetadataMap: WeakMapDatapoints;
};

export const XYChartDataContext = createContext<XYChartDataContext | undefined>(
  undefined,
);

XYChartDataContext['displayName'] = 'XYChartDataContext';
